// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2026 
import { ICookieManager, ICookieConsent } from '../../../../CommonScripts/Abstractions';
/**
* Manages getting and setting cookies
*/
export class CookieManager implements ICookieManager, ICookieConsent{
    /**
    * @private
    */
    private m_consentCookieName: string;
    /**
    * The constructor
    * @public
    */
    constructor() {
        this.m_consentCookieName = 'cookieConsent';
    }
    /**
    * @inheritdoc 
    */
    create(name : string, value : string, days: number): void {
        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        else
            expires = '';
        document.cookie = document.location.pathname + '_' + name + '=' + encodeURIComponent(value) + expires + '; path=/';
    }
    /**
    * @inheritdoc
    */
    read (name: string) : string{
        var nameEQ = document.location.pathname + '_' + name + '=';
        var ca = document.cookie.split(';');
        var val = null;
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ')
                c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0)
                val = c.substring(nameEQ.length, c.length);
        }
        return decodeURIComponent(val);
    }
    /**
    * @inheritdoc
    */
    eraseCookie(name: string): void{
        this.create(name, '', -1);
    }
    /**
    * @inheritdoc
    */
    haveConsent() : boolean {
        var consent = this.read(this.m_consentCookieName);
        var bConsent = consent === 'true';
        let gtag: (config: string, type: string, setting: any) => void = window['gtag']
        if (gtag !== undefined) {
            var permission = 'denied';
            if (bConsent)
                permission = 'granted';

            gtag('consent', 'update', { 'analytics_storage': permission });
        }
        return bConsent;
    }
    /**
    * @inheritdoc
    */
    setConsent() {
        let gtag: (config: string, type: string, setting: any) => void = window['gtag']
        if (gtag !== undefined) {
            gtag('consent', 'update', { 'analytics_storage': 'granted' });
        }

        this.create(this.m_consentCookieName, true.toString(), 3600);
    }
    /**
    * @inheritdoc
    */
    removeConsent () : void {
        var consent = this.read(this.m_consentCookieName);
        if (consent !== 'null')
            this.eraseCookie(this.m_consentCookieName);
        let gtag: (config: string, type: string, setting: any) => void = window['gtag']
        if (gtag !== undefined) {
            gtag('consent', 'update', { 'analytics_storage': 'denied' });
        }

    }
};


